"use client";
import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.css";

const MoreContent = ({ children }) => {
  const [height, setHeight] = useState("auto");

  const ref = useRef(null);

  useEffect(() => {
    setHeight("auto");
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner} style={{ height }} ref={ref}>
        {children}
      </div>
    </div>
  );
};

MoreContent.propTypes = {
  children: PropTypes.node,
  defaultHeight: PropTypes.number,
};

export default MoreContent;
